/**
 * Hook zum Laden aller Flurstücke eines Projekts (reine Anzeige).
 * Schlanke Alternative zu useParcelsData — kein Selektions-State, keine Notizen.
 */
import { useState, useEffect, useCallback } from 'react';
import { parcelsApi } from '../../../services/api/parcels';

export function useProjectParcels(projectId: string | undefined) {
  const [parcels, setParcels] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!projectId) return;
    setLoading(true);
    try {
      const data = await parcelsApi.getParcels(projectId);
      setParcels(data ?? []);
    } catch {
      setParcels([]);
    } finally {
      setLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    if (!projectId) {
      setLoading(false);
      return;
    }
    load();
  }, [projectId, load]);

  return { parcels, loading, reload: load };
}
